const asString = (value, defaultValue = "") =>
    typeof value === "string" ? value : defaultValue;

const asNumber = (value, defaultValue = 0) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string") {
    const parsed = Number(value.trim());
    return Number.isFinite(parsed) ? parsed : defaultValue;
  }

  return defaultValue;
};

const asBoolean = (value) => value === true;

const asNullableValue = (value) =>
    value === undefined ? null : value;

export function normalizeAssociatedWorkkardListItem(item = {}) {
    return {
        WkId: asNumber(item.wk_id || item.WkId),
        WkNumber: asString(item.wk_number || item.WkNumber),
        WkStatus: asString(item.wk_status || item.WkStatus),
        OrganizationName: asString(item.organization_name || item.OrganizationName),
        SponsorId: asNumber(item.sponsor_id || item.SponsorId),
        SponsorName: asString(item.sponsor_name || item.SponsorName),
        IsSponsorActive: asBoolean(item.is_sponsor_active || item.IsSponsorActive),
        ProfileImageURL: asString(item.profile_image_url || item.ProfileImageURL),
        DynamicFields: asNullableValue(item.dynamic_fields || item.DynamicFields),
        OrgId: asNumber(item.org_id || item.OrgId),
        AssigneeOrgId: asNumber(item.assignee_org_id || item.AssigneeOrgId),
        IsViewable: asBoolean(item.is_viewable ?? item.IsViewable),
        IsWorkkardClickable: asBoolean(item.is_workkard_clickable ?? item.IsWorkkardClickable),
        TemplateType: asString(item.template_type || item.TemplateType),
        FieldKey: asString(item.field_key || item.FieldKey),
        FieldValue: asString(item.field_value || item.FieldValue),
    };
}
